import api from '@/libs/axiosInstance';
import type { ApiResponse, MentionArchiveAcknowledgmentStatusDto } from '@fluenceur/types';
import { useQuery } from '@tanstack/react-query';

export const archiveAcknowledgmentStatusQueryKey = ['archive-acknowledgment-status'] as const;

const fetchStatus = async (): Promise<MentionArchiveAcknowledgmentStatusDto> => {
  const response = await api.get<ApiResponse<MentionArchiveAcknowledgmentStatusDto>>(
    '/dashboard/mentions/archive/acknowledgment-status'
  );

  if (response.data.success && response.data.data) {
    return response.data.data;
  }

  throw new Error(response.data.message || 'Failed to fetch archive acknowledgment status');
};

/**
 * Returns whether the current user has gone through the full Save-to-Drive
 * three-checkbox ceremony for the active brand. Same TTL semantics as the
 * download equivalent (sliding 7 days backend-side, 5min stale window).
 */
export const useArchiveAcknowledgmentStatusQuery = () => {
  return useQuery<MentionArchiveAcknowledgmentStatusDto, Error>({
    queryKey: archiveAcknowledgmentStatusQueryKey,
    queryFn: fetchStatus,
    staleTime: 5 * 60 * 1000,
  });
};
